import { render } from "./hospitalManage.vue?vue&type=template&id=2ec43908&scoped=true"
import script from "./hospitalManage.vue?vue&type=script&lang=js"
export * from "./hospitalManage.vue?vue&type=script&lang=js"

import "./hospitalManage.vue?vue&type=style&index=0&id=2ec43908&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2ec43908"

export default script